export default __webpack_public_path__ + "static/media/dropbox-icon.02cfd5a1.svg";